import { render, staticRenderFns } from "./BAT.vue?vue&type=template&id=36ad0f86&scoped=true&"
import script from "./BAT.vue?vue&type=script&lang=js&"
export * from "./BAT.vue?vue&type=script&lang=js&"
import style0 from "./BAT.vue?vue&type=style&index=0&id=36ad0f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad0f86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})
